/** Query keys for Phase 10: insights, access, billing, developers, account, the console. */
export const platformKeys = {
  all: () => ['platform'] as const,
  dashboard: (campusId: string | null) => [...platformKeys.all(), 'dashboard', campusId] as const,
  report: (definition: unknown) => [...platformKeys.all(), 'report', definition] as const,
  reports: () => [...platformKeys.all(), 'reports'] as const,
  roles: () => [...platformKeys.all(), 'roles'] as const,
  billing: () => [...platformKeys.all(), 'billing'] as const,
  mediaUsage: () => [...platformKeys.all(), 'media-usage'] as const,
  aiCredits: () => [...platformKeys.all(), 'ai-credits'] as const,
  apiKeys: () => [...platformKeys.all(), 'api-keys'] as const,
  webhooks: () => [...platformKeys.all(), 'webhooks'] as const,
  deliveries: (endpointId: string) => [...platformKeys.all(), 'deliveries', endpointId] as const,
  events: () => [...platformKeys.all(), 'events'] as const,
  exports: () => [...platformKeys.all(), 'exports'] as const,
  deletion: () => [...platformKeys.all(), 'deletion'] as const,
  audit: (filters: Record<string, string | undefined>) =>
    [...platformKeys.all(), 'audit', filters] as const,
  adminOrgs: () => [...platformKeys.all(), 'admin', 'orgs'] as const,
  adminOrg: (id: string) => [...platformKeys.all(), 'admin', 'org', id] as const,
  adminPlans: () => [...platformKeys.all(), 'admin', 'plans'] as const,
  adminLog: () => [...platformKeys.all(), 'admin', 'log'] as const,
  adminSpotify: () => [...platformKeys.all(), 'admin', 'spotify'] as const,
  adminAi: () => [...platformKeys.all(), 'admin', 'ai'] as const,
  adminChurchCredits: (id: string) => [...platformKeys.all(), 'admin', 'org', id, 'ai'] as const,
  adminCatalog: () => [...platformKeys.all(), 'admin', 'catalog'] as const,
  adminCatalogSearch: (q: string) => [...platformKeys.adminCatalog(), 'search', q] as const,
  adminCatalogSong: (id: string) => [...platformKeys.adminCatalog(), 'song', id] as const,
}
